<div [formGroup]="filterForm">
    <p class="filter-help">
        All filters are combined with AND. Field names and values are case-insensitive. A product missing any filtered
        field is excluded, including for “not equals”.
    </p>
    <div formArrayName="filters">
        @for (filter of filters.controls; track filter; let i = $index) {
            <div [formGroupName]="i" class="filter-criteria d-flex flex-column">
                <!-- Property Name Field -->
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Property Name</mat-label>
                    <input formControlName="propertyName" matInput placeholder="Enter property name">
                    @if (filter.get('propertyName')?.invalid && filter.get('propertyName')?.touched) {
                        <mat-error>
                            Property name is required.
                        </mat-error>
                    }
                </mat-form-field>
                <!-- Operation Field -->
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Operation</mat-label>
                    <mat-select formControlName="operation">
                        @for (op of operations; track op) {
                            <mat-option [value]="op">
                                {{ op }}
                            </mat-option>
                        }
                    </mat-select>
                    @if (filter.get('operation')?.invalid && filter.get('operation')?.touched) {
                        <mat-error>
                            Operation is required.
                        </mat-error>
                    }
                </mat-form-field>
                <!-- Value Field -->
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Value</mat-label>
                    <input formControlName="value" matInput placeholder="Enter value">
                    @if (filter.get('value')?.invalid && filter.get('value')?.touched) {
                        <mat-error>
                            Value is required.
                        </mat-error>
                    }
                </mat-form-field>
                <!-- Remove Filter Button -->
                <button (click)="removeFilter(i)" aria-label="Remove Filter" color="warn" mat-icon-button>
                    <mat-icon>remove_circle</mat-icon>
                </button>
            </div>
        }
    </div>

    <!-- Add Filter Button -->
    <div class="add-filter-button">
        <button mat-raised-button color="primary" type="button" (click)="addFilter()">Add Filter</button>
    </div>
</div>
